import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import LoginIcon from '@mui/icons-material/Login';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const formatDate = dateString => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

const APJobseekerList = () => {
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const { t } = useTranslation('global');
  const adminID = Cookies.get('adminID');

  const [open, setOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectAll, setSelectAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkedData, setCheckedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [positionFrom, setPositionFrom] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const page = 1;
  const per_page = 20;

  const indexOfFirstItem = positionFrom;
  const indexOfLastItem = (positionFrom + per_page) >= totalCount ? totalCount : (positionFrom + per_page - 1);

  const handlePageChange = async page => {
    try {
      const positionNumber = page * per_page - per_page;

      setLoading(true);
      setCurrentPage(page);
      setPositionFrom(positionNumber);

      const response = await axios.get(
        BaseApi + '/admin/candidates/index',
        {
          params: {
            page,
            per_page,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response.data);
      setTotalCount(response.data.response.total);
      setPositionFrom(response.data.response.from);
      setTotalPages(response.data.response.last_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const handleOpen = plan => {
    setSelectedPayment(plan);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedPayment(null);
    setOpen(false);
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/candidates/index',
        {
          params: {
            page,
            per_page,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response.data);
      setTotalCount(response.data.response.total);
      setPositionFrom(response.data.response.from);
      setTotalPages(response.data.response.last_page);
    } catch (error) {
      setLoading(false);

      console.error('Cannot get plans data at APmanageplans');
    }
  };

  const handleSearchClick = async e => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/candidates/index',
        {
          params: {
            page,
            per_page,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setCurrentPage(1);
      setListData(response.data.response.data);
      setTotalCount(response.data.response.total);
      setPositionFrom(response.data.response.from);
      setTotalPages(response.data.response.last_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const handleActivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Jobseeker?',
        text: 'Do you want to Activate this Jobseeker?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/candidates/activateuser/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseeker Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Jobseeker',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleDeactivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Jobseeker?',
        text: 'Do you want to Deactivate this Jobseeker?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/candidates/deactivateuser/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseeker Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Jobseeker',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleDelete = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Delete Jobseeker?',
        text: 'Do you want to Delete this Jobseeker?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/candidates/deleteusers/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseeker deleted successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Delete Jobseeker',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t delete the record!', error.message);
    }
  };

  const handleLogIn = async jobseekerID => {
    try {
      const response = await axios.get(
        BaseApi + `/admin/auth-user/${jobseekerID}`,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      if (response.data.status === 200) {
        const { token, user_id, user_type, first_name } = response.data.response.user;

        Cookies.set('user_id', user_id);
        Cookies.set('fname', first_name);
        Cookies.set('tokenClient', token);
        Cookies.set('user_type', user_type);

        window.open('/candidates/my-cv-list', '_blank');
      } else if (response.data.status === 500) {
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Close',
          title: response.data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Close',
          title: 'Couldn\'t Log In!',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Log In Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t Log In the Employer!', error.message);
    }
  };

  const handleCheck = id => {
    if (id === 'selectAll') {
      setSelectAll(!selectAll);

      const updatedCheckedData = selectAll
        ? listData.map(item => item.id)
        : [];
      setCheckedData(updatedCheckedData);
    } else {
      if (checkedData.includes(id)) {
        setCheckedData(checkedData.filter(checkedId => checkedId !== id));
      } else {
        setCheckedData([...checkedData, id]);
      }
    }
  };

  const handleMultipleDeactivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Jobseekers?',
        text: 'Do you want to Deactivate these Jobseekers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.join(',');

        const response = await axios.post(
          BaseApi + '/admin/candidates/index',
          {
            idList: ids,
            action: 'deactivate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseekers Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Deactivate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Jobseekers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleMultipleActivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Jobseekers?',
        text: 'Do you want to Activate these Jobseekers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.toString();

        const response = await axios.post(
          BaseApi + '/admin/candidates/index',
          {
            idList: ids,
            action: 'activate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseekers Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Activate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Jobseekers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleMultipleDelete = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Delete Jobseekers?',
        text: 'Do you want to Delete these Jobseekers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.toString();

        const response = await axios.post(
          BaseApi + '/admin/candidates/index',
          {
            idList: ids,
            action: 'delete',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Jobseekers Deleted successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Delete!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Delete Jobseekers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t Delete the record!', error.message);
    }
  };

  const handleSearchChange = e => {
    const newQuery = e.target.value.toLowerCase();
    setSearchQuery(newQuery);
  };

  const handleExport = () => {
    const fileUrl = BaseApi + '/admin/candidates/generatecsv';

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = fileUrl;

    link.download = 'Export List';

    document.body.appendChild(link);

    link.click();
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin APJobseekerList'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('')}
                    >
                      Jobseekers
                    </Link>
                    <Typography color='text.primary'>Jobseeker List</Typography>
                  </Breadcrumbs>
                </div>
                <div className='ManageSubAdminHeader'>
                  <h2 className=''>Jobseeker List</h2>
                  <button className='btn navButton1 APMSbutton' onClick={() => handleExport()}>
                    Export Jobseeker
                  </button>
                  <button className='btn navButton1 APMSbutton' onClick={() => navigate('/admin/candidates/addcandidates')}>
                    Add Jobseeker
                  </button>
                </div>
                <div className='manageSubadminPart1'>
                  <form onSubmit={handleSearchClick}>
                    <div className='manageSubadminPart1Sec1'>
                      <h4>
                        Search jobseeker by typing ID, Name, Email, Contact Number or Created date
                      </h4>
                      <div className='APDashboardSearchBx '>
                        <input
                          type='text'
                          id='searchQuery'
                          name='searchQuery'
                          value={searchQuery}
                          placeholder='Search..'
                          className='form-control'
                          onChange={handleSearchChange}
                        />
                      </div>
                      <button
                        type='submit'
                        className='btn button1'
                        onClick={handleSearchClick}
                      >
                        Search
                      </button>
                    </div>
                  </form>
                  <h4>
                    {t('pagination.NoofRecords')}
                    {' '}
                    {indexOfFirstItem} - {indexOfLastItem}
                    {' '}{t('pagination.of')}{' '}
                    {totalCount}
                  </h4>
                </div>
                {
                  listData != '' ? (
                    <>
                      <div className='manageSubadminPart2'>
                        <table className='table'>
                          <thead>
                            <tr>
                              <td className='checkBoxCol checkBxHead'>
                                <input
                                  type='checkbox'
                                  className='tableCheckBox'
                                  onClick={() => handleCheck('selectAll')}
                                />
                              </td>
                              <th>Jobseeker ID</th>
                              <th>Full Name</th>
                              <th>Email</th>
                              <th>Contact Number</th>
                              <th><CalendarMonthIcon /> Created</th>
                              <th scope='col'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              listData.map(i => (
                                <tr key={i.id}>
                                  <td className='checkBoxCol'>
                                    <input
                                      type='checkbox'
                                      className='tableCheckBox'
                                      onChange={() => handleCheck(i.id)}
                                      checked={checkedData.includes(i.id)}
                                    />
                                  </td>
                                  <td>{i.id}</td>
                                  <td>{i.first_name} {i.last_name}</td>
                                  <td>{i.email_address}</td>
                                  <td>{i.contact}</td>
                                  <td>{formatDate(i.created)}</td>
                                  <td className='APActionButton'>
                                    {
                                      i.status === 1 ? (
                                        <button className='btn btn-secondary activated' onClick={() => handleDeactivate(i.slug)}>
                                          <Tooltip title='Deactivate'>
                                            <CheckIcon />
                                          </Tooltip>
                                        </button>
                                      ) : (
                                        <button className='btn btn-secondary' onClick={() => handleActivate(i.slug)}>
                                          <Tooltip title='Activate'>
                                            <BlockIcon />
                                          </Tooltip>
                                        </button>
                                      )
                                    }
                                    <button className='btn btn-primary' onClick={() => navigate(`/admin/candidates/editcandidates/${i.slug}`)}>
                                      <Tooltip title='Edit'>
                                        <CreateIcon />
                                      </Tooltip>
                                    </button>
                                    <button className='btn btn-primary' onClick={() => handleOpen(i)}>
                                      <Tooltip title='View'>
                                        <RemoveRedEyeIcon />
                                      </Tooltip>
                                    </button>
                                    <button className='btn btn-primary' onClick={() => navigate(`/admin/jobs/applied/${i.slug}`)}>
                                      <Tooltip title='Applied Job List'>
                                        <FormatListBulletedIcon />
                                      </Tooltip>
                                    </button>
                                    <button className='btn btn-secondary' onClick={() => handleDelete(i.slug)}>
                                      <Tooltip title='Delete'>
                                        <DeleteIcon />
                                      </Tooltip>
                                    </button>
                                    <button
                                      className='btn-primary'
                                      onClick={() => handleLogIn(i.id)}
                                    >
                                      <Tooltip title='View'>
                                        <LoginIcon />
                                      </Tooltip>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                      <div className='manageSubadminpart3'>
                        <div className='functionalityButton'>
                          <button
                            type='button'
                            className='btn btn-primary APButton3'
                            onClick={() => handleMultipleActivate()}
                          >
                            ACTIVATE
                          </button>
                          <button
                            type='button'
                            className='btn btn-primary APButton3'
                            onClick={() => handleMultipleDeactivate()}
                          >
                            DEACTIVATE
                          </button>
                          <button
                            type='button'
                            className='btn btn-primary APButton4'
                            onClick={() => handleMultipleDelete()}
                          >
                            DELETE
                          </button>
                        </div>
                        <div className='mb-5 pagination'>
                          <Stack spacing={2}>
                            <Pagination
                              color='primary'
                              boundaryCount={2}
                              count={totalPages}
                              page={currentPage}
                              onChange={(event, page) => handlePageChange(page)}
                            />
                          </Stack>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className='appliedJobListNoData mt-5'>
                      No Records Found
                    </div>
                  )
                }
                <div>
                  <Modal
                    open={open}
                    className='modalMain'
                    onClose={handleClose}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                  >
                    <Box className='modal adminModal modal-content'>
                      <IconButton
                        onClick={handleClose}
                        className='close-button'
                        style={{
                          position: 'absolute',
                          top: 10,
                          right: 10,
                        }}
                      >
                        &times;
                      </IconButton>
                      <Typography
                        variant='h6'
                        component='h2'
                        id='modal-modal-title'
                      ></Typography>
                      <Box id='modal-modal-description' sx={{ mt: 3 }}>
                        {
                          selectedPayment && (
                            <div className='modals '>
                              <div className='modalHead'>
                                <h1>
                                  {selectedPayment.first_name}{' '}
                                  {selectedPayment.last_name}
                                </h1>
                              </div>
                              <div className='modalBody mt-4'>
                                <div className='modalParent'>
                                  <div className='modalLeft'>
                                    First Name:{' '}
                                  </div>
                                  <div className='modalRight'>
                                    {selectedPayment.first_name}
                                  </div>
                                </div>
                                <div className='modalParent'>
                                  <div className='modalLeft'>
                                    Last Name:{' '}
                                  </div>
                                  <div className='modalRight'>
                                    {selectedPayment.last_name}
                                  </div>
                                </div>
                                <div className='modalParent'>
                                  <div className='modalLeft'>
                                    Email Address:{' '}
                                  </div>
                                  <div className='modalRight'>
                                    {selectedPayment.email_address}
                                  </div>
                                </div>
                                <div className='modalParent'>
                                  <div className='modalLeft'>
                                    Location:{' '}
                                  </div>
                                  <div className='modalRight'>
                                    {selectedPayment.location}
                                  </div>
                                </div>
                                <div className='modalParent'>
                                  <div className='modalLeft'>
                                    Contact Number:{' '}
                                  </div>
                                  <div className='modalRight'>
                                    {selectedPayment.contact}
                                  </div>
                                </div>
                                <div className='modalParent'>
                                  <div className='modalLeft'>Video: </div>
                                  <div className='modalRight'>
                                    {selectedPayment.video}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </Box>
                    </Box>
                  </Modal>
                </div>
              </div>
            )
        }
      </div>
    </>
  );
};

export default APJobseekerList;
